import { useState, useEffect } from 'react';
import { usePaperTrading } from '../contexts/PaperTradingContext';
import { fetchMarketBySlug } from '../services/marketService';

export const useRecommendations = () => {
    const { positions } = usePaperTrading();
    const [recommendations, setRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const analyzePositions = async () => {
            if (!positions || positions.length === 0) {
                setRecommendations([]);
                setLoading(false);
                return;
            }

            setLoading(true);
            const newRecs = [];

            for (const pos of positions) {
                try {
                    const marketData = await fetchMarketBySlug(pos.marketSlug);
                    if (!marketData) continue;

                    // Analyze based on platform_prediction
                    const consensus = marketData.platform_prediction || 'UNKNOWN';
                    const userSide = pos.side.toUpperCase();

                    let type = 'INFO';
                    let message = `Monitoring your ${userSide} position.`;

                    if (consensus !== 'UNKNOWN') {
                        if (userSide !== consensus) {
                            type = 'WARNING';
                            message = `Network consensus leans ${consensus}. Consider hedging your ${userSide} position.`;
                        } else {
                            type = 'SUCCESS';
                            message = `Network consensus aligns with your ${userSide} position. Hold strong.`;
                        }
                    }

                    // For aggressive modes or high volume
                    if (pos.value < pos.invested * 0.8) {
                        type = 'DANGER';
                        message = `Position down 20%+. Evaluate exit strategy for ${pos.marketTitle}.`;
                    }

                    newRecs.push({
                        id: `${pos.marketSlug}-${pos.side}`,
                        marketTitle: pos.marketTitle,
                        marketSlug: pos.marketSlug,
                        positionSide: userSide,
                        type,
                        message,
                        timestamp: new Date().toISOString()
                    });
                } catch (error) {
                    console.error("Error analyzing position:", pos.marketSlug, error);
                }
            }

            setRecommendations(newRecs);
            setLoading(false);
        };

        analyzePositions();

        // Refresh every 60s
        const interval = setInterval(analyzePositions, 60000);
        return () => clearInterval(interval);
    }, [positions]);

    return {
        recommendations,
        count: recommendations.filter(r => r.type === 'WARNING' || r.type === 'DANGER').length,
        loading
    };
};
